module.exports = __webpack_public_path__ + "img/pass_card_2.d50d61f7.png";